import store from "../../store";
import Errors from "../../Errors";
import CartHelpersMixin from "../../mixins/CartHelpersMixin";
import CartItemHelpersMixin from "../../mixins/CartItemHelpersMixin";

export default {
    mixins: [CartHelpersMixin, CartItemHelpersMixin],
    props: [
        "customerEmail",
        "customerPhone",
        "gateways",
        "defaultAddress",
        "addresses",
        "countries",
    ],

    data() {
        return {
            shippingMethodName: null,
            crossSellProducts: [],
            crossPreorderProducts: [],
            errors: new Errors(),
            sell_form: {
                customer_email: this.customerEmail,
                customer_phone: this.customerPhone,
                billing: {},
                newBillingAddress: false,
                billingAddressId: null,
            },
            preorder_form: {
                customer_email: this.customerEmail,
                customer_phone: this.customerPhone,
                billing: {},
                newBillingAddress: false,
                billingAddressId: null,
            },
            states: {
                billing: {},
                shipping: {},
            },
        };
    },

    computed: {
        hasAddress() {
            return this.addresses !== undefined ? Object.keys(this.addresses).length !== 0 : false;
        },
        hasAnyCrossSellProduct() {
            console.log('crossSellProducts', this.crossSellProducts);
            return this.crossSellProducts.length !== 0;
        },
        // preorderIsNotEmpty() {
        //     return store.state.preorder && store.state.preorder.items && store.state.preorder.items.length > 0;
        // },
        // preorderItems() {
        //     return store.state.preorder?.items || [];
        // },
        hasAnyCrossPreorderProduct() {
            return this.crossPreorderProducts.length !== 0;
        },
    },

    created() {
        if (!this.hasAddress) {
            this.sell_form.newBillingAddress = true;
        }
        if (!this.hasAddress) {
            this.preorder_form.newBillingAddress = true;
        }

        this.$nextTick(() => {
            if (store.state.cart.shippingMethodName) {
                this.changeShippingMethod(store.state.cart.shippingMethodName);
            } else {
                this.updateShippingMethod(this.firstShippingMethod);
            }

            this.fetchCrossSellProducts();
            this.fetchCrossPreorderProducts();
        });

    },

    methods: {

        updatePreorderCart(cartItem, qty) {
            this.loadingOrderSummary = true;

            axios
                .put(route("preorder.items.update", { id: cartItem.id }), {
                    qty: qty || 1,
                })
                .then((response) => {
                    store.updatePreorderCart(response.data);
                })
                .catch(({ response }) => {
                    store.updatePreorderCart(response.data.cart);
                    this.$notify(response.data.message);
                })
                .finally(() => {
                    this.loadingOrderSummary = false;
                });
        },

        removePreorderItem(cartItem) {
            this.loadingOrderSummary = true;

            store.removePreorderItem(cartItem);

            if (store.preorderIsEmpty()) {
                this.crossPreorderProducts = [];
            }

            axios
                .delete(route("preorder.items.destroy", { id: cartItem.id }))
                .then((response) => {
                    store.updatePreorderCart(response.data);
                    console.log('delete', response);
                })
                .catch((error) => {
                    this.$notify(error.response.data.message);
                })
                .finally(() => {
                    this.loadingOrderSummary = false;
                });
        },

        clearPreorderCart() {
            store.clearPreorderCart();

            if (store.preorderIsEmpty()) {
                this.crossPreorderProducts = [];
            }

            axios
                .delete(route("preorder.clear"))
                .then((response) => {
                    store.updatePreorderCart(response.data);
                })
                .catch((error) => {
                    this.$notify(error.response.data.message);
                });
        },


        updateCart(cartItem, qty) {
            this.loadingOrderSummary = true;

            axios
                .put(route("cart.items.update", { id: cartItem.id }), {
                    qty: qty || 1,
                })
                .then((response) => {
                    store.updateCart(response.data);
                })
                .catch(({ response }) => {
                    store.updateCart(response.data.cart);

                    this.$notify(response.data.message);
                })
                .finally(() => {
                    this.loadingOrderSummary = false;
                });
        },

        updateSellCart(cartItem, qty) {
            this.loadingOrderSummary = true;

            axios
                .put(route("sell.items.update", { id: cartItem.id }), {
                    qty: qty || 1,
                })
                .then((response) => {
                    store.updateSellCart(response.data);
                })
                .catch(({ response }) => {
                    store.updateSellCart(response.data.cart);

                    this.$notify(response.data.message);
                })
                .finally(() => {
                    this.loadingOrderSummary = false;
                });
        },

        removeCartItem(cartItem) {
            this.loadingOrderSummary = true;

            store.removeCartItem(cartItem);

            if (store.cartIsEmpty()) {
                this.crossSellProducts = [];
            }

            axios
                .delete(route("cart.items.destroy", { id: cartItem.id }))
                .then((response) => {
                    store.updateCart(response.data);
                })
                .catch((error) => {
                    this.$notify(error.response.data.message);
                })
                .finally(() => {
                    this.loadingOrderSummary = false;
                });
        },

        clearCart() {
            store.clearCart();

            if (store.cartIsEmpty()) {
                this.crossSellProducts = [];
            }

            axios
                .delete(route("cart.clear"))
                .then((response) => {
                    store.updateCart(response.data);
                })
                .catch((error) => {
                    this.$notify(error.response.data.message);
                });
        },

        clearSellCart() {
            store.clearSellCart();

            if (store.sellIsEmpty()) {
                this.crossSellProducts = [];
            }

            axios
                .delete(route("sell.clear"))
                .then((response) => {
                    store.updateSellCart(response.data);
                })
                .catch((error) => {
                    this.$notify(error.response.data.message);
                });
        },

        changeShippingMethod(shippingMethodName) {
            this.shippingMethodName = shippingMethodName;
        },

        async fetchCrossPreorderProducts() {
            try {
                const response = await axios.get(
                    route("cart.cross_preorder_products.index")
                );

                this.crossPreorderProducts = response.data;
            } catch (error) {
                this.$notify(error.response.data.message);
            }
        },


        async fetchCrossSellProducts() {
            try {
                const response = await axios.get(
                    route("cart.cross_sell_products.index")
                );

                this.crossSellProducts = response.data;
            } catch (error) {
                this.$notify(error.response.data.message);
            }
        },
        onChangePaymentCategory(type) {
            let subTotal = 0;
            $.each(store.state.sell.items, function (index, val) {
                if (val.cashPrice.amount !== '') {
                    if (type == 'cash') {
                        subTotal += parseFloat(val.cashPrice.amount * val.qty);
                    } else {
                        subTotal += parseFloat(val.creditPrice.amount * val.qty);
                    }
                }
            });
            subTotal = parseFloat(subTotal).toFixed(2);
            store.state.sell.payment_category = type;

            store.state.sell.subTotal = subTotal;
            store.state.sell.total = subTotal;
        },
        onChangePaymentCategoryPreorder(type) {
            let subTotal = 0;

            $.each(store.state.preorder.items, function (index, val) {
                if (val.item.variant.formatted_price !== '') {
                    subTotal += parseFloat(val.item.variant.selling_price.inCurrentCurrency.amount * val.qty);
                }
            });

            subTotal = parseFloat(subTotal).toFixed(2);

            // Vuex store update
            store.state.preorder.payment_category = type;
            store.state.preorder.subTotal = subTotal;
            store.state.preorder.total = subTotal;

            // Local binding for template
            this.preorder.payment_category = type;
            this.preorder.subTotal = subTotal;
            this.preorder.total = subTotal;
        },
        
        processSellModal() {
            $("#processSellModal").modal('show');
        },
        onCloseModal() {
            $("#processSellModal").modal('hide');
        },
        processPreorderModal() {
            $("#processPreorderModal").modal('show');
        },
        onCloseModal() {
            $("#processPreorderModal").modal('hide');
        },
        changeBillingCity(city) {
            this.$set(this.sell_form.billing, "city", city);
        },
        changeBillingCountry(country) {
            this.$set(this.sell_form.billing, "country", country);

            if (country === "") {
                this.sell_form.billing.state = "";
                this.states.billing = {};

                return;
            }

            this.fetchStates(country, (response) => {
                this.$set(this.states, "billing", response.data);
                this.$set(this.sell_form.billing, "state", "");
            });
        },
        changeBillingZip(zip) {
            this.$set(this.sell_form.billing, "zip", zip);
        },
        fetchStates(country, callback) {
            axios
                .get(route("countries.states.index", { code: country }))
                .then(callback);
        },
        onSellConfirm() {
            axios.post(
                route("sell.order.store"),
                {
                    ...this.sell_form,
                    ...store.state.sell
                }
            )
                .then((response) => {
                    console.log(response.data)
                    if (response.data.type == 'success') {
                        this.clearSellCart();
                        window.location.href = route("account.sells.index");
                    }
                    this.$notify(response.data.message);
                })
                .catch((error) => {
                    console.log('error');
                    /*this.placingOrder = false;
                    this.loadingOrderSummary = false;

                    this.deleteOrder(orderId);*/
                    this.$notify(error.response.data.message);
                });
        },
        onPreorderConfirm() {
            axios.post(
                route("preorder.order.store"),
                    {
                        ...this.preorder_form,
                        ...store.state.preorder
                    }
                )
                .then((response) => {
                    console.log('post preorder response',response.data)
                    if (response.data.type == 'success') {
                        this.clearPreorderCart();
                        window.location.href = route("account.preorders.index");
                    }
                    this.$notify(response.data.message);
                })
                .catch((error) => {
                    console.log('error');
                    /*this.placingOrder = false;
                    this.loadingOrderSummary = false;

                    this.deleteOrder(orderId);*/
                    this.$notify(error.response.data.message);
                });
        },
        
    },

    mounted() {
            this.onChangePaymentCategoryPreorder('preorder');
        },
};
